import Color from 'color';
import { MINIMUM_CONTRAST_RATIO } from '../constants/colorConst';

export const getRGBFromHex = (hex) => {
    if (!hex) {
        return undefined;
    }

    // const { r, g, b } = rgb;
    const color = Color(hex);

    return color.rgb().object();
};

export const getHexFromRGB = (rgb) => {
    if (!rgb) {
        return undefined;
    }

    const color = Color(rgb);

    return color.hex().toLowerCase();
};

export const getContrastRatio = (hex1, hex2) => {
    let contrastRatio;

    if (!hex1 || !hex2) {
        return contrastRatio;
    }

    const color1 = Color(hex1);
    const color2 = Color(hex2);

    contrastRatio = color1.contrast(color2).toFixed(1);

    return contrastRatio;
};

// Will check that color choices are compliant within WCAG 2.0 specs:
// https://www.w3.org/TR/UNDERSTANDING-WCAG20/visual-audio-contrast-contrast.html
export const wcagContrastCheck = (hex1, hex2) => {
    if (!hex1 || !hex2) {
        return false;
    }

    const contrastRatio = getContrastRatio(hex1, hex2);

    return contrastRatio >= MINIMUM_CONTRAST_RATIO;
};

export const isValidHexColor = (hex) => {
    // const regex = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;
    const regex = /^#([0-9a-f]{6})$/i;
    const isValid = !!hex.match(regex);

    return isValid;
};

export const fixHexMissingHash = (hex) => {
    const regex = /^([0-9a-f]{3}|[0-9a-f]{6})$/i;
    const isJustMissingHash = !!hex.match(regex);

    if (isJustMissingHash) {
        return `#${hex}`;
    }

    return hex;
};

export const parseColorStrToRGBA = (colorStr) => {
    let rgba;

    if (!colorStr) {
        return rgba;
    }

    const isRGBA = colorStr.search('rgba') === 0;
    const isHex = colorStr.search('#') === 0 && colorStr.length === 7;

    if (!isRGBA && !isHex) {
        return rgba;
    }

    if (!isRGBA) {
        const rgb = getRGBFromHex(colorStr);
        rgba = { ...rgb, a: 1 };
    } else {
        const rgbaArr = colorStr
            .replace(/\s/g, '')
            .replace('rgba(', '')
            .replace(')', '')
            .split(',');
        const [r, g, b, a] = rgbaArr;

        rgba = { r, g, b, a };
    }

    return rgba;
};

export const convertColorStringToHex = (colorStr) => {
    const rgba = undefined;

    if (!colorStr) {
        return rgba;
    }

    if (colorStr === 'transparent') {
        return colorStr;
    }

    const { r, g, b } = parseColorStrToRGBA(colorStr);

    return getHexFromRGB({ r, g, b });
};

export const getHoverColor = (colorStr) => {
    let rgba;

    if (!colorStr) {
        return rgba;
    }

    rgba = parseColorStrToRGBA(colorStr);
    const rgb = { r: rgba.r, g: rgba.g, b: rgba.b };
    const color = Color(rgb);
    const isDark = color.isDark();
    const hsl = color.hsl().object();
    const { h, s, l: lightness } = hsl;
    const adjustBy = 10;
    const darker = lightness - adjustBy < 0 ? 0 : lightness - adjustBy;
    const lighter = lightness + adjustBy > 100 ? 100 : lightness + adjustBy;
    const l = isDark ? darker : lighter;
    const newColor = Color({
        h: Math.round(h),
        s: Math.round(s),
        l: Math.round(l),
    });

    return newColor.hex().toLowerCase();
};
